import { render, staticRenderFns } from "./game.vue?vue&type=template&id=02013b22&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "./game.vue?vue&type=style&index=0&id=02013b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02013b22",
  null
  
)

export default component.exports